module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jobEmail"
  }, [_c('div', {
    staticClass: "jobContainer"
  }, _vm._l((_vm.docs), function(item) {
    return _c('div', {
      staticClass: "jobList"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.data1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.data2))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.data3))])])
  })), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    attrs: {
      "id": "jobH3"
    }
  }, [_vm._v("一些人等着被世界改变"), _c('br'), _vm._v("而我们已经在"), _c('br'), _vm._v("改变世界")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email"
  }, [_c('div', [_vm._v("更多职位")]), _vm._v(" "), _c('p', [_vm._v("联系方式：hr@ofo.so")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1c103ab5"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/jobContent.vue
// module id = 17
// module chunks = 0